// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Vp0x8O7OXUorZQTLnQbz{grid-template-rows:1fr;padding:20px 0 0;display:grid}.il0Xe7S1srE6e7KBcA_c{padding:5px 0}.jfHQ5vgEEySOQhoPN47E{padding:50px 0}.mJVF04xIXhs9r9xrXQ5B{color:var(--content-primary-tertiary);justify-content:center;padding:37.5px 12px 17.5px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Vp0x8O7OXUorZQTLnQbz`,
	"loadingMore": `il0Xe7S1srE6e7KBcA_c`,
	"loading": `jfHQ5vgEEySOQhoPN47E`,
	"empty": `mJVF04xIXhs9r9xrXQ5B`
};
export default ___CSS_LOADER_EXPORT___;
